import { useAppSelector } from '@/redux/store';

const usePaymentStatus = (): 'success' | 'pending' | undefined =>
  useAppSelector((state) => state.payment.status);

export { usePaymentStatus };
